import axios from 'axios';
import { listPayload } from './billingReconciliationMockApi.js';

const BASE_URL = '/api/billing-reconciliation';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
);
const requestConfig = (params = {}, signal = undefined) => ({
  params: cleanParams(params),
  ...(signal ? { signal } : {}),
});

const encoded = (value) => encodeURIComponent(String(value));

export const listBillingReconciliationAppSheetRows = async ({ runId, signal, ...params } = {}) => {
  if (!runId) return { accounts: [], orderItems: [], source: { tables: [] } };
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/appsheet-rows`, requestConfig(params, signal));
  return data;
};

export const listBillingReconciliationAppSheetBacAccounts = async ({ runId, signal, ...params } = {}) => {
  if (!runId) return { accounts: [], total: 0, source: { table: null } };
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/appsheet-bac-accounts`, requestConfig(params, signal));
  return data;
};

export const searchBillingReconciliationAppSheetAccounts = async ({ runId, signal, ...params } = {}) => {
  if (!runId) return listPayload([]);
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/appsheet-accounts`, requestConfig(params, signal));
  return Array.isArray(data) ? listPayload(data) : data;
};
